// extracted by mini-css-extract-plugin
module.exports = {"bottomRightPosition":"styles-module__bottomRightPosition___r-OFQ"};